const basePath = 'workspace/plan'
export const ROUTER_WORKSPACE_PLAN = {
	root: `/${basePath}`,
	list_plan: `/${basePath}/select-plan`,
	usage: `/${basePath}/usage-billings`,
	invoices: `/${basePath}/invoices`
}

export const TRANSLATE_WORKSPACE_PLAN_SETTING = `${basePath}`
